import {useState} from 'react';
import {useBetween} from 'use-between';

export const cardBlockedNotificationHeight = 36;

const useCardBlockedNotificationHeightState = () => {
  const [height, setHeight] = useState(cardBlockedNotificationHeight);

  return {height, setHeight};
};

export const useCardBlockedNotificationHeight = () => useBetween(useCardBlockedNotificationHeightState);
